export const DEFAULT_PO_NOTES = [
    "Material TC Endorsement Should be properly done for traceability.",
    "All Rolled Section material should be in 12 mtr length.",
    "Physical copy of TC should be Provided with the vehicle with endorsement."
];

export const DEFAULT_PO_NOTES_HTML = `
<ol>
  <li>Material TC Endorsement Should be properly done for traceability.</li>
  <li>All Rolled Section material should be in 12 mtr length.</li>
  <li>Physical copy of TC should be Provided with the vehicle with endorsement.</li>
</ol>
`;

export const DEFAULT_COMMON_MAKE = "";

export const quillModules = {
    toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ color: [] }, { background: [] }],
        ["clean"],
    ],
};

export const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "color",
    "background",
];

export const formatINR = (val) => {
    const num = Number(val || 0);
    return new Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(num);
};

export const numberToWords = (num) => {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
        'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const rounded = Math.round(Number(num || 0));
    if (rounded === 0) return 'Zero Rupees Only';

    const n = ('000000000' + rounded).slice(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return '';

    let str = '';
    const getTwoDigit = (val) => {
        val = Number(val);
        if (val < 20) return a[val];
        return b[Math.floor(val / 10)] + (val % 10 ? ' ' + a[val % 10] : '');
    };

    if (Number(n[1])) str += getTwoDigit(n[1]) + ' Crore ';
    if (Number(n[2])) str += getTwoDigit(n[2]) + ' Lakh ';
    if (Number(n[3])) str += getTwoDigit(n[3]) + ' Thousand ';
    if (Number(n[4])) str += a[Number(n[4])] + ' Hundred ';

    if (Number(n[5])) {
        str += (str !== '' ? 'and ' : '') + getTwoDigit(n[5]) + ' ';
    }

    return str.trim() + ' Rupees Only';
};
